import { NewTicketQueryParams, PaginationOptions } from 'types';

// Type and ServiceLevel
const ACCOUNT_EXCLUSION_TYPES = {
  managed_gcp: 'Runway',
  azure: 'Navigator',
};

const NONE_SELECTED = 'None Selected';

const CTUI = 'CTUI';

const NPST = 'NPS-T';

const NPS_RELATED_EVENT_TYPES = {
  process: 'process',
  device: 'device',
  ticket: 'ticket',
  invoice: 'invoice',
  notification: 'notification',
};

const NPS_RELATED_EVENT_CATEGORIES = {
  service: 'service',
  serviceBlock: 'service block',
  product: 'product',
};

const CES_EVENT_TYPES = {
  TICKET: 'ticket',
};

const CES_EVENT_CATEGORIES = {
  SERVICE: 'service',
};

const CES = 'CES';
const PILOT_DIV_ID = '#nav-pilot';

const KEVALIN_COLLECTIONS = {
  CUSTOMER_NPS: 'SERVICE.CUSTOMER.NPS',
  CTUI_PREFERENCES: 'SERVICE.CTUI.PREFS',
  CES: 'SERVICE.CUSTOMER.CSAT',
};

const BROWSER_NAMES = ['Edg', 'Chrome', 'MSIE', 'Firefox', 'Safari', 'Opera'];

const COLLECTIONS = {
  DEVICE_FILTER: 'DEVICE_FILTER',
  DEVICE: 'DEVICE',
  TICKETS_DEVICES: 'TICKETS_DEVICES',
  GROUP: 'GROUP',
  SEVERITY: 'SEVERITY',
  TEMPLATE: 'TEMPLATE',
  TICKET_EXPORT: 'TICKET_EXPORT',
  TICKET: 'TICKET',
  ALL_CONTACTS: 'ALL_CONTACTS',
};

const DEFAULT_NEW_TICKET_QUERYPARAMS: NewTicketQueryParams = {
  new_ticket: false,
  new_ticket_id: null,
  new_ticket_dedicated: null,
};

const COMMENT_FORMAT = {
  BBCODE: 'bbcode',
  PLAIN: 'plain',
};

const DEFAULT_PAGE_SIZES = [10, 25, 50];

const DEVICES_PAGINATION: PaginationOptions = {
  defaultItemsPerPage: 10,
  stateKey: 'devices',
  pageSizes: [10, 25, 50],
};

const INPUT_REQUEST_DEBOUNCE = 600;

const PERMISSION_TAGS = {
  DEVICES_SUPPORTED: 'devices:supported',
  DEVICES_MANDATORY: 'devices:mandatory',
  TEMPLATES_SUPPORTED: 'templates:supported',
  PRODUCT_RAS: 'product:ras',
};

const POLLING_MAX_RETRIES = 120;

const REACH_TEMPLATES = [
  'cbslimitincrease',
  'cdnhttps',
  'ramandserverlimitincrease',
  'ramlimitincrease',
  'serverdiscount',
  'serverlimitincrease',
];

const MOBILE_NAMES = [
  'Android',
  'webOS',
  'iPhone',
  'iPad',
  'BlackBerry',
  'Windows Phone',
];
const MODAL_STATES = {
  ERROR: 'ERROR',
  INITIAL: 'INITIAL',
  SUCCESS: 'SUCCESS',
};

const SELECTED_DEVICES_PAGINATION: PaginationOptions = {
  defaultItemsPerPage: 10,
  stateKey: 'selectedDevices',
  pageSizes: [10, 25, 50],
};

const TEMPLATE_IDS = [
  'serverlimitincrease',
  'ramlimitincrease',
  'serverdiscount',
  'ramandserverlimitincrease',
  'cbslimitincrease',
  'cdnhttps',
];

const TICKETS_PAGINATION: PaginationOptions = {
  defaultItemsPerPage: 25,
  stateKey: 'tickets',
  pageSizes: [10, 25, 50],
};

const TOAST_TIMEOUT = 12000;

const TICKETLIST_TICKETDETAILS_COMMON_PROPERTIES = ['subject', 'status'];
const CLOUD_ONLY_COMMON_PROPERTIES = ['classification', 'severity'];
const TICKETLIST_MODIFIED_PROPERTY = 'modified';

const USER_BROWSER_DETAILS = {
  browserDetails: 'Browser details',
  browserDimensions: 'Browser dimensions',
  deviceDetails: 'Device details',
};

const FEEDBACK_RATING_ARRAY = [
  {
    label: 'cesSurvey:stronglyDisagree', value: 'Strongly Disagree',
    imageURL: "data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg width='48px' height='48px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EGroup%3C/title%3E%3Cg id='Emojis' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Group'%3E%3Ccircle id='Oval' fill='%23FF7581' cx='24' cy='24' r='24'%3E%3C/circle%3E%3Cpath d='M13.4472136,12.1055728 L21.4472136,16.1055728 C21.9411921,16.3525621 22.1414164,16.9532351 21.8944272,17.4472136 C21.6868545,17.862359 21.2294778,18.0700281 20.7955666,17.9791312 C20.9276581,18.4537379 21,18.966007 21,19.5 C21,21.9852814 19.4329966,24 17.5,24 C15.5670034,24 14,21.9852814 14,19.5 C14,17.7866621 14.7447403,16.2969657 15.840717,15.5368445 L12.5527864,13.8944272 C12.0588079,13.6474379 11.8585836,13.0467649 12.1055728,12.5527864 C12.3525621,12.0588079 12.9532351,11.8585836 13.4472136,12.1055728 Z M34.5527864,12.1055728 C35.0467649,11.8585836 35.6474379,12.0588079 35.8944272,12.5527864 C36.1414164,13.0467649 35.9411921,13.6474379 35.4472136,13.8944272 L32.1595357,15.5370197 C33.2553742,16.2971947 34,17.7867937 34,19.5 C34,21.9852814 32.4329966,24 30.5,24 C28.5670034,24 27,21.9852814 27,19.5 C27,18.9656286 27.0724445,18.4530118 27.2053949,17.9774992 C26.7719237,18.0706637 26.3134634,17.8629947 26.1055728,17.4472136 C25.8585836,16.9532351 26.0588079,16.3525621 26.5527864,16.1055728 Z M24,29 C29.0040475,29 32.9815474,31.1695454 35.8320503,35.4452998 C36.1384028,35.9048285 36.0142289,36.5256978 35.5547002,36.8320503 C35.0951715,37.1384028 34.4743022,37.0142289 34.1679497,36.5547002 C31.6851193,32.8304546 28.3292859,31 24,31 C19.6707141,31 16.3148807,32.8304546 13.8320503,36.5547002 C13.5256978,37.0142289 12.9048285,37.1384028 12.4452998,36.8320503 C11.9857711,36.5256978 11.8615972,35.9048285 12.1679497,35.4452998 C15.0184526,31.1695454 18.9959525,29 24,29 Z' id='Combined-Shape' fill='%23333333'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
  },
  {
    label: 'cesSurvey:disagree', value: 'Disagree',
    imageURL: "data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg width='48px' height='48px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cg id='Emojis' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Group-2'%3E%3Ccircle id='Oval' fill='%23FF9C4D' cx='24' cy='24' r='24'%3E%3C/circle%3E%3Cpath d='M17.5,24 C19.4329966,24 21,21.9852814 21,19.5 C21,17.0147186 19.4329966,15 17.5,15 C15.5670034,15 14,17.0147186 14,19.5 C14,21.9852814 15.5670034,24 17.5,24 Z M30.5,24 C32.4329966,24 34,21.9852814 34,19.5 C34,17.0147186 32.4329966,15 30.5,15 C28.5670034,15 27,17.0147186 27,19.5 C27,21.9852814 28.5670034,24 30.5,24 Z M24,29 C29.0040475,29 32.9815474,31.1695454 35.8320503,35.4452998 C36.1384028,35.9048285 36.0142289,36.5256978 35.5547002,36.8320503 C35.0951715,37.1384028 34.4743022,37.0142289 34.1679497,36.5547002 C31.6851193,32.8304546 28.3292859,31 24,31 C19.6707141,31 16.3148807,32.8304546 13.8320503,36.5547002 C13.5256978,37.0142289 12.9048285,37.1384028 12.4452998,36.8320503 C11.9857711,36.5256978 11.8615972,35.9048285 12.1679497,35.4452998 C15.0184526,31.1695454 18.9959525,29 24,29 Z' id='Combined-Shape' fill='%23333333'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
  },
  {
    label: 'cesSurvey:neutral', value: 'Neutral',
    imageURL: "data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg width='48px' height='48px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cg id='Emojis' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Group-3'%3E%3Ccircle id='Oval' fill='%23FFDE5C' cx='24' cy='24' r='24'%3E%3C/circle%3E%3Cpath d='M17.5,24 C19.4329966,24 21,21.9852814 21,19.5 C21,17.0147186 19.4329966,15 17.5,15 C15.5670034,15 14,17.0147186 14,19.5 C14,21.9852814 15.5670034,24 17.5,24 Z M30.5,24 C32.4329966,24 34,21.9852814 34,19.5 C34,17.0147186 32.4329966,15 30.5,15 C28.5670034,15 27,17.0147186 27,19.5 C27,21.9852814 28.5670034,24 30.5,24 Z M35,32 C35.5522847,32 36,32.4477153 36,33 C36,33.5522847 35.5522847,34 35,34 L13,34 C12.4477153,34 12,33.5522847 12,33 C12,32.4477153 12.4477153,32 13,32 L35,32 Z' id='Combined-Shape' fill='%23333333'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
  },
  {
    label: 'cesSurvey:agree', value: 'Agree',
    imageURL: "data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg width='48px' height='48px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EGroup 4%3C/title%3E%3Cg id='Emojis' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Group-4'%3E%3Ccircle id='Oval' fill='%2383F377' cx='24' cy='24' r='24'%3E%3C/circle%3E%3Cpath d='M17.5,24 C19.4329966,24 21,21.9852814 21,19.5 C21,17.0147186 19.4329966,15 17.5,15 C15.5670034,15 14,17.0147186 14,19.5 C14,21.9852814 15.5670034,24 17.5,24 Z M30.5,24 C32.4329966,24 34,21.9852814 34,19.5 C34,17.0147186 32.4329966,15 30.5,15 C28.5670034,15 27,17.0147186 27,19.5 C27,21.9852814 28.5670034,24 30.5,24 Z M24,37 C29.0040475,37 32.9815474,34.8304546 35.8320503,30.5547002 C36.1384028,30.0951715 36.0142289,29.4743022 35.5547002,29.1679497 C35.0951715,28.8615972 34.4743022,28.9857711 34.1679497,29.4452998 C31.6851193,33.1695454 28.3292859,35 24,35 C19.6707141,35 16.3148807,33.1695454 13.8320503,29.4452998 C13.5256978,28.9857711 12.9048285,28.8615972 12.4452998,29.1679497 C11.9857711,29.4743022 11.8615972,30.0951715 12.1679497,30.5547002 C15.0184526,34.8304546 18.9959525,37 24,37 Z' id='Combined-Shape' fill='%23333333'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
  },
  {
    label: 'cesSurvey:stronglyAgree', value: 'Strongly Agree',
    imageURL: "data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg width='48px' height='48px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EGroup 5%3C/title%3E%3Cg id='Emojis' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Group-5' transform='translate(0, 0)'%3E%3Ccircle id='Oval' fill='%235AE150' cx='24' cy='24' r='24'%3E%3C/circle%3E%3Cpath d='M17.5,24 C19.4329966,24 21,21.9852814 21,19.5 C21,17.0147186 19.4329966,15 17.5,15 C15.5670034,15 14,17.0147186 14,19.5 C14,21.9852814 15.5670034,24 17.5,24 Z M30.5,24 C32.4329966,24 34,21.9852814 34,19.5 C34,17.0147186 32.4329966,15 30.5,15 C28.5670034,15 27,17.0147186 27,19.5 C27,21.9852814 28.5670034,24 30.5,24 Z M12,29 L35.6923077,29 C35.6923077,35.0302502 30.8355952,39.9354469 24.8056425,39.995346 C24.4920432,39.9984424 24.1722137,40 23.8461538,40 C23.520094,40 23.2002645,39.9984424 22.8866654,39.9953273 L22.8866652,39.995346 C16.8567125,39.9354469 12,35.0302502 12,29 L12,29 L12,29 Z' id='Combined-Shape' fill='%23333333'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
  }
]

const FEEDBACK_CHOICES = [
  { label: 'cesSurvey:resResTime', value: 'Response/Resolution Time' },
  { label: 'cesSurvey:communication', value: 'Communication' },
  { label: 'cesSurvey:technicalExpertise', value: 'Technical Expertise' },
  { label: 'cesSurvey:proactiveness', value: 'Proactiveness/Ownership' },
  { label: 'cesSurvey:ticketingPortalExperience', value: 'Ticketing Portal Experience' },
];

const LATEST_TICKET_DETAILS = {
  TicketId: 'Latest Ticket ID',
};

const TICKET_TEMPLATE_GUIDE = {
  TicketTemplateGuide:
    'https://docs.rackspace.com/support/how-to/rackspace-fabric/',
};

const SOLUTIONS_DASHBORAD_URL =
  'https://manage.rackspace.com/dashboard/?status=Active';

const CUSTOMER_ICON_SVG = `
<svg width="30px" height="31px" viewBox="0 0 30 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>Icon person</title>
  <g id="🔷-Details-Comments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Icon-person">
        <path d="M0,15 C0,23.285625 6.71625,30 15,30 C23.28375,30 30,23.285625 30,15 C30,6.714375 23.28375,0 15,0 C6.71625,0 0,6.714375 0,15 Z" id="Stroke-1" fill="#6CA3E1"></path>
        <circle id="Oval" fill="#FFFFFF" cx="15" cy="11.325" r="5.625"></circle>
        <path d="M14.976,16.9 C20.153,16.9 24.351,21.098 24.351,26.275 L24.351,26.735 C21.783,28.794 18.523,30.025 14.976,30.025 C11.428,30.025 8.168,28.794 5.6,26.735 L5.601,26.275 C5.601,21.098 9.799,16.9 14.976,16.9" id="Fill-1" fill="#FFFFFF"></path>
    </g>
  </g>
</svg>
`;

const RACKER_ICON_SVG = `
<svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>Icon racl</title>
  <g id="🔷-Details-Comments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Icon-racl">
      <circle id="Oval" fill="#212121" cx="15" cy="15" r="15"></circle>
        <g id="Rackspace_Icon_White" transform="translate(7.000000, 5.000000)" fill="#FFFFFF" fill-rule="nonzero">
            <path d="M6.76144183,19.2249806 L6.73934191,19.3411024 L6.48365396,19.3411024 L6.35827664,20 L6.23205488,20 L6.3574322,19.3411135 L6.10046648,19.3411135 L6.1225664,19.2249917 L6.76144183,19.2249806 Z M7.70721613,19.2249806 L7.55975001,20 L7.43352825,20 L7.53677231,19.4574131 L7.22211791,19.8250895 L7.14674041,19.8250895 L6.97219661,19.4563353 L6.86876366,20 L6.74253079,20 L6.89000802,19.2249806 L7.00397427,19.2249806 L7.21414016,19.6689234 L7.59302766,19.2249806 L7.70721613,19.2249806 Z M7.91117094,4.70377842 L8.72065685,0.443227401 L3.71954189,0.443227401 L0,20 L5.67960136,20 L7.21325128,11.9365074 C8.11753685,7.18166931 10.8455157,5.27894297 14.7277237,5.86671859 L15.836864,0.0334066847 C12.4652406,-0.277392675 9.27290059,1.60375696 7.91117094,4.70377842 L7.91117094,4.70377842 Z" id="Shape"></path>
        </g>
      </g>
  </g>
</svg>
`;

const MAINTENANCE_URL = '#';

const SCREEN_SIZE_768 = 768;

const CANCEL_BUTTON_ID = 'cancel-btn';

const PRIVACY_STATEMENT_URL =
  'https://www.rackspace.com/information/legal/privacystatement';
const TERMS_URL = 'https://www.rackspace.com/information/legal/websiteterms';

const DRAWER_TYPES = {
  NONE: '',
  TICKET_DETAILS: 'TICKET_DETAILS',
  CLOSE_TICKET: 'CLOSE_TICKET',
  ADD_RECIPIENT: 'ADD_RECIPIENT',
  ADD_GROUP: 'ADD_GROUP',
  FILTER: 'FILTER',
};

const NOT_A_MOBILE = 'Not a mobile device';

const DEV_SUPPORT_CENTER_URL = 'https://dev.manage.rackspace.com/support/';

const SUPPORT_CENTER_URL = 'https://manage.rackspace.com/support/';

const RESOURCE_ID_FILTER = 'resourceID';

const ADD_PARAM = 'add';

const REMOVE_PARAM = 'remove';

const SESSION_EMAIL_KEY = 'urn:oid:1.2.840.113549.1.9.1.1';

export {
  ACCOUNT_EXCLUSION_TYPES,
  ADD_PARAM,
  BROWSER_NAMES,
  COLLECTIONS,
  COMMENT_FORMAT,
  DEFAULT_NEW_TICKET_QUERYPARAMS,
  DEFAULT_PAGE_SIZES,
  DEVICES_PAGINATION,
  DRAWER_TYPES,
  INPUT_REQUEST_DEBOUNCE,
  MOBILE_NAMES,
  MODAL_STATES,
  PERMISSION_TAGS,
  PILOT_DIV_ID,
  POLLING_MAX_RETRIES,
  REACH_TEMPLATES,
  REMOVE_PARAM,
  RESOURCE_ID_FILTER,
  SELECTED_DEVICES_PAGINATION,
  TEMPLATE_IDS,
  TICKETS_PAGINATION,
  TOAST_TIMEOUT,
  TICKETLIST_TICKETDETAILS_COMMON_PROPERTIES,
  CLOUD_ONLY_COMMON_PROPERTIES,
  TICKETLIST_MODIFIED_PROPERTY,
  USER_BROWSER_DETAILS,
  NONE_SELECTED,
  NOT_A_MOBILE,
  CTUI,
  NPST,
  NPS_RELATED_EVENT_TYPES,
  NPS_RELATED_EVENT_CATEGORIES,
  CES_EVENT_TYPES,
  CES_EVENT_CATEGORIES,
  CES,
  LATEST_TICKET_DETAILS,
  KEVALIN_COLLECTIONS,
  TICKET_TEMPLATE_GUIDE,
  RACKER_ICON_SVG,
  CUSTOMER_ICON_SVG,
  MAINTENANCE_URL,
  FEEDBACK_RATING_ARRAY,
  FEEDBACK_CHOICES,
  SCREEN_SIZE_768,
  CANCEL_BUTTON_ID,
  PRIVACY_STATEMENT_URL,
  TERMS_URL,
  DEV_SUPPORT_CENTER_URL,
  SESSION_EMAIL_KEY,
  SUPPORT_CENTER_URL,
  SOLUTIONS_DASHBORAD_URL,
};
